import { LimitsIcon } from '@/shared/assets';
import { Button, Typography } from '@/shared/ui';

interface ReviewDetailsItemProps {
  title: string;
  value?: string;
  linkLabel?: string;
  onLinkClick?: () => void;
}
export const ReviewDetailsItem = ({
  title,
  value,
  linkLabel,
  onLinkClick,
}: ReviewDetailsItemProps) => {
  return (
    <div className="flex min-h-[64px] flex-col py-2.5">
      <Typography variant="12-r" color="text-base-100" className="break-words">
        {title}
      </Typography>
      {linkLabel && onLinkClick ? (
        <Button
          type="button"
          variant="blue-link"
          size="16-r"
          className="h-auto flex justify-start gap-1"
          onClick={onLinkClick}
        >
          <LimitsIcon className="h-6 w-6" />
          {linkLabel}
        </Button>
      ) : <Typography variant="16-r" className="break-words">
        {value ?? '-'}
      </Typography>}
    </div>
  );
};
